"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Client = void 0;

var _sdkFetch = _interopRequireDefault(require("@energych/sdk-fetch"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Client =
/*#__PURE__*/
function () {
  /**
   * Create a new client instance
   *
   * @param connector
   */
  function Client(connector) {
    _classCallCheck(this, Client);

    this.connector = connector;

    _defineProperty(this, "storage", void 0);

    _defineProperty(this, "accessToken", void 0);

    _defineProperty(this, "canRenew", false);

    _defineProperty(this, "isRenualOn", false);
  }
  /**
   * Logout the user
   */


  _createClass(Client, [{
    key: "fetchAuthorized",

    /**
     * Fetch an url and automatically apend the authoriation header
     *
     * @param url
     * @param options
     */
    value: function fetchAuthorized(url, options) {
      if (!this.accessToken || !this.accessToken.isValid()) {
        return (0, _sdkFetch.default)(url, options);
      }

      return (0, _sdkFetch.default)(url, _objectSpread({}, options || {}, {
        headers: _objectSpread({}, options && options.headers ? options.headers : {}, {
          Authorization: "Bearer ".concat(this.accessToken.getToken())
        })
      }));
    }
    /**
     * Get the basic user information
     *
     * @param forceFetch
     */

  }, {
    key: "getUser",
    value: function getUser(forceFetch) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (!_this.accessToken || !_this.accessToken.isValid()) {
          _this.onInvalidToken();

          return reject(null);
        }

        if (!_this.isRenualOn) {
          _this.checkForTokenRenewal('auto', 3000 * 1000);
        }

        var cacheKey = "user.".concat(_this.accessToken.getToken());

        if (!forceFetch && _this.connector.getCache(cacheKey)) {
          return resolve(_this.connector.getCache(cacheKey));
        }

        _this.fetchAuthorized(_this.connector.getConfig().userinfoApi).then(function (res) {
          return res.json();
        }).then(function (user) {
          if (user && user.sub) {
            _this.connector.setCache(cacheKey, user, 3600 * 1000);

            resolve(user);
          } else {
            reject(user);
          }
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
    /**
     * Get the user id
     *
     * @param forceFetch
     */

  }, {
    key: "getUserId",
    value: function getUserId() {
      if (!this.accessToken || !this.accessToken.isValid()) {
        return null;
      }

      return this.accessToken.getParsedToken().sub;
    }
    /**
     * Check if the user is still logged in
     */

  }, {
    key: "isLoggedIn",
    value: function isLoggedIn() {
      var _this2 = this;

      return new Promise(function (resolve) {
        _this2.connector.getConfig().env === 'tools' ? _this2.getUser(false).then(function () {
          return resolve(true);
        }).catch(function () {
          return resolve(false);
        }) : _this2.getMetadata(false, _this2.connector.getConfig().brand).then(function () {
          return resolve(true);
        }).catch(function () {
          return resolve(false);
        });
      });
    }
    /**
     * Get the metadata of the logged in user
     *
     * @param forceFetch
     * @param profile
     */

  }, {
    key: "getMetadata",
    value: function getMetadata(forceFetch, profile) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        if (!_this3.accessToken || !_this3.accessToken.isValid()) {
          _this3.onInvalidToken();

          return reject(null);
        }

        if (!_this3.isRenualOn) {
          _this3.checkForTokenRenewal('auto', 3000 * 1000);
        }

        var cacheKey = "metadata.".concat(_this3.accessToken.getToken());

        if (!forceFetch && _this3.connector.getCache(cacheKey)) {
          return resolve(_this3.connector.getCache(cacheKey));
        }

        var userId = encodeURIComponent(_this3.getUserId() || '');

        _this3.fetchAuthorized("".concat(_this3.connector.getConfig().metadataApi, "/users/").concat(userId, "?brand=").concat(profile)).then(function (res) {
          return res.json();
        }).then(function (metadata) {
          if (metadata && metadata.email && metadata.sub) {
            _this3.connector.setCache(cacheKey, metadata, 30 * 1000);

            resolve(metadata);
          } else {
            reject(metadata);
          }
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
    /**
     * Set a new access token. Returns false if it is invalid (expired or the issuer does not match)
     *
     * @param accessToken
     */

  }, {
    key: "setAccessToken",
    value: function setAccessToken(accessToken) {
      if (!accessToken.isValid()) {
        return false;
      }

      if (accessToken.getParsedToken().iss !== this.connector.getConfig().issuer) {
        this.connector.log('warn', 'issuer does not match');
        return false;
      } // For Onelog/RSSO we get the client id inside the aud field, our auth0 uses the azp field.


      var clientId = this.connector.getConfig().env === 'tools' ? accessToken.getParsedToken().azp : accessToken.getParsedToken().aud;

      if (clientId !== this.connector.getConfig().clientId) {
        this.connector.log('warn', 'clientId do not match');
        return false;
      }

      this.accessToken = accessToken;
      return true;
    }
    /**
     * Checks if the token is soon to expire and should get renewed
     *
     * @param {string} mode - renew mode
     * @param {number} time - time before a token runs out and gets renewed
     */

  }, {
    key: "checkForTokenRenewal",
    value: function checkForTokenRenewal(mode) {
      var _this4 = this;

      var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3300 * 1000;

      if (!this.canRenew || !this.accessToken || !this.accessToken.isValid() || this.connector.getConfig().tokenRenewMode !== mode) {
        return;
      }

      if (this.accessToken.getExpiresAt() - new Date().getTime() < time && !this.isRenualOn) {
        this.isRenualOn = true; // delay it a bit so it doesn't get instantly renewed on a page load

        setTimeout(function () {
          if (_this4.canRenew && _this4.accessToken && _this4.accessToken.isValid()) {
            _this4.renewToken();
          }

          _this4.isRenualOn = false;
        }, Math.floor(Math.random() * 20 + 20) * 1000);
      }
    }
    /**
     * Renew the token.
     * This method should get overwritten in the client if he wants to support it
     */

  }, {
    key: "renewToken",
    value: function renewToken() {// to be implemented in the client if he wants to support it
    }
  }]);

  return Client;
}();

exports.Client = Client;